module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Light.a30bd49593af93873832a3afaf65648d.eot";